

























import Vue, { PropOptions } from 'vue';
import { Campaign, CampaignStatus } from '@/models';
import ModalConfirmationCancel from '@/components/campaign/ModalConfirmationCancel.vue';
export default Vue.extend({
  components: { ModalConfirmationCancel },
  props: {
    tooltip: {
      type: Boolean,
      default: true,
    },
    iconSize: {
      type: Number,
      default: 16,
    },
    iconName: String,
    color: String,
    label: String,
    buttonClass: String,
  },
});
